export default "__VITE_PUBLIC_ASSET__012cef63__"